<ng-container *ngIf="visible">
  <button
    class="btn btn-lg rounded-0 btn-outline-primary"
    (click)="opened = !opened">
    Transcriptions
  </button>
  <div
    class="card border shadow-none"
    *ngIf="opened"
    cdkDrag
    cdkDragBoundary="#layout-wrapper">
    <div class="card-header" cdkDragHandle>
      <div class="row justify-content-between align-items-center">
        <div class="col">
          <h5 class="mb-0">Available Transcriptions</h5>
        </div>
        <div class="col-auto text-end">
          <button
            (click)="opened = false"
            type="button"
            aria-label="Close"
            class="btn-close"></button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <ng-scrollbar [autoHeightDisabled]="false">
        <ngb-accordion #accordion="ngbAccordion" [activeIds]="['0']">
          <ngb-panel
            *ngFor="let interview of interviews; let i = index"
            id="{{ i }}">
            <ng-template ngbPanelTitle>
              <div class="w-100">
                <div class="pe-3">
                  <div class="row justify-content-between align-items-center">
                    <div class="col">
                      <audio controls class="w-100">
                        <source [src]="interview.media.url" />
                        Your browser does not support the audio element.
                      </audio>
                    </div>
                    <div class="col-auto text-end">
                      {{ interview.createdAt | date }}
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <p *ngFor="let transcription of interview.transcriptions">
                {{ transcription.text }}
              </p>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </ng-scrollbar>
    </div>
  </div>
</ng-container>
